import { Col, Modal, Row, Form, Input } from 'antd';
import * as React from 'react';
import { Provider } from 'unstated';

import { StateContainer } from './StateContainer';

interface ILanguageDetailProps {
    language: GQL.ILanguage;
    onSave: (language: GQL.ILanguage) => void;
    onCancel: () => void;
}

export default class LanguageDetail extends React.Component<ILanguageDetailProps> {
    private languageContainer: StateContainer;

    public constructor(props: ILanguageDetailProps) {
        super(props);
        this.languageContainer = new StateContainer({
            language: props.language
        });

        this.save = this.save.bind(this);
    }

    public render() {
        const { language } = this.languageContainer.state;

        return (
            <Provider>
                <Modal
                    // maskClosable={false}
                    style={{ top: '5vh' }}
                    width={'50%'}
                    bodyStyle={{ minHeight: '80vh' }}
                    title={`Language ${language && language.value}`}
                    visible={true}
                    cancelText={'Close'}
                    okText={'Save changes'}
                    onOk={this.save}
                    onCancel={() => this.props.onCancel()}
                >
                    <Row>
                        <Col span={24}>
                            <Form>
                                <Form.Item
                                    validateStatus={this.languageContainer.state.errors.value ? 'error' : undefined}
                                    help={this.languageContainer.state.errors.value}
                                >
                                    <Input
                                        autoFocus={true}
                                        name={'value'}
                                        placeholder="Language's value"
                                        defaultValue={language.value}
                                        onChange={e => this.onChange('value', e.target.value)}
                                    />
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                </Modal>
            </Provider>
        );
    }
    private onChange(key: string, val: any) {
        this.languageContainer.onChange(key, val);
    }

    private async save() {
        const errors = await this.languageContainer.validate(); // TODO
        let anyError = false;

        for (const key of Object.keys(errors)) {
            if (errors[key] != undefined) {
                anyError = true;
            }
        }

        if (!anyError) {
            this.props.onSave(this.languageContainer.state.language);
        } else {
            console.log('there is error, can not save', errors);
        }
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Languages/LanguageDetail/LanguageDetail.tsx